var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"normal",staticClass:"zm-sticky"},[_vm._t("default"),_c('div',{ref:"sticky",staticClass:"zm-sticky-fixed",class:_vm.appendCls})],2)}
var staticRenderFns = []

export { render, staticRenderFns }